import { useState, useMemo } from 'react';
import { PageSizeType } from 'design-system-web';
import { TableFilter } from '../types';

type SortConfig = {
  id: string;
  direction: 'asc' | 'desc';
};

type PaginationConfig = {
  index: number;
  size: PageSizeType;
};

const DEFAULT_SORT: SortConfig = {
  id: 'name',
  direction: 'asc',
};

const DEFAULT_PAGINATION: PaginationConfig = {
  index: 0,
  size: 50,
};

export const useTableControls = () => {
  const [page, setPage] = useState<PaginationConfig>(DEFAULT_PAGINATION);
  const [searchKey, setSearchKey] = useState('');
  const [filters, setFilters] = useState<TableFilter[]>([]);
  const [sortBy, setSortBy] = useState<SortConfig>(DEFAULT_SORT);

  return useMemo(
    () => ({
      page,
      searchKey,
      filters,
      sortBy,
      setPage,
      setSearchKey,
      setFilters,
      setSortBy,
    }),
    [page, searchKey, filters, sortBy]
  );
};
